import React, { useState } from 'react';
import { SubjectSelection, TestTypeSelection, RecentTests, AIChat, ComingSoonOverlay, AIStudyTips } from '../components/mock-test';

const MockTest: React.FC = () => {
  const [selectedSubject, setSelectedSubject] = useState<string | null>(null);
  const [showComingSoon, setShowComingSoon] = useState(true);
  const [showAIChat, setShowAIChat] = useState(false);

  return (
    <div className="min-vh-100" style={{ backgroundColor: '#f8f9ff', paddingTop: '0px' }}>
      <div className="container py-5">
        <div className="row">
          <div className="col-12">
            {/* Header */}
            <div className="text-center mb-5">
              <h1 className="fw-bold mb-3" style={{ 
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                AI-Powered Mock Tests
              </h1>
              <p className="text-muted fs-5">
                Take personalized tests that adapt to your learning pace and focus on your weak areas
              </p>
              
              {/* AI Chat Toggle Button */}
              <button
                className="btn btn-primary btn-sm mt-2"
                onClick={() => setShowAIChat(true)}
                style={{ 
                  borderRadius: '25px',
                  background: 'linear-gradient(135deg, #667eea, #764ba2)',
                  border: 'none'
                }}
              >
                <i className="fas fa-robot me-2"></i>
                Chat with AI Assistant
              </button>
            </div>

            {/* AI Study Tips */}
            <AIStudyTips />

            {/* Test Components with Coming Soon Overlay */}
            <div className="position-relative">
              {/* Subject Selection */}
              {/* <SubjectSelection 
                selectedSubject={selectedSubject} 
                onSubjectSelect={setSelectedSubject} 
              /> */}

              {/* Test Types */}
              {/* <TestTypeSelection selectedSubject={selectedSubject} /> */}

              {/* Recent Tests */}
              {/* <RecentTests /> */}

              {/* Coming Soon Overlay */}
              {showComingSoon && (
                <ComingSoonOverlay onDismiss={() => setShowComingSoon(false)} />
              )}
            </div>

            {/* AI Chat Component */}
            {showAIChat && (
              <AIChat onClose={() => setShowAIChat(false)} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MockTest;